(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('LoginSettingsController', LoginSettingsController);

  LoginSettingsController.$inject = ['$http', '$state', '$rootScope', 'CompanyService', 'NotificationService'];

  function LoginSettingsController ($http, $state, $rootScope, CompanyService, NotificationService) {
    var vmLoginCtrl = this;

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmLoginCtrl.metadata = data;
        if (!vmLoginCtrl.metadata.auth_settings) {
          vmLoginCtrl.metadata.auth_settings = {
            'type': 'local'
          };
        }
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
      });

    vmLoginCtrl.setLoginSettings = function () {
      CompanyService
        .saveMetadata(vmLoginCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.saveConfig);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig);
        });
    };
  }
})();
